import { ExecutionModeEnum } from '@/types/enums/execution-mode.enum';

export const ExecutionModeOptions: {
    label: string;
    value: ExecutionModeEnum;
}[] = [
    { label: 'Offline', value: ExecutionModeEnum.Offline },
    { label: 'Online', value: ExecutionModeEnum.Online },
];
